import { put, call } from "redux-saga/effects";
import axios from "../../axiosConfig";
import {
  ACCOUNT_VERIFICATION_FAILED,
  ACCOUNT_VERIFICATION_SUCCESS,
  FORGET_PASSWORD_FAILED,
  FORGET_PASSWORD_SUCCESS,
  FORGET_VALIDATE_OTP_FAILED,
  FORGET_VALIDATE_OTP_SUCCESS,
  GET_USER_FOUND,
  GET_USER_NOT_FOUND,
  LOGOUT_SUCCESS,
  REGISTER_USER_FAILED,
  REGISTER_USER_SUCCESS,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
  VALIDATE_OTP_FAILED,
  VALIDATE_OTP_SUCCESS,
  EMAIL_VERIFICATION_FAILED,
  EMAIL_VERIFICATION_SUCCESS,
  REGISTER_EXISTING_USER_SUCCESS,
  REGISTER_EXISTING_USER_FAILED,
  GET_EDITOR_FAILED,
  GET_EDITOR_SUCCESS,
  REMOVE_EDITOR_SUCCESS,
  REMOVE_EDITOR_FAILED,
} from "../Actions/AuthActions";
import { CLEAR_BULLETIN_SUCCESS } from "../Actions/BulletinAction";
import { CLEAR_EXPLORE_SUCCESS } from "../Actions/ExploreAction";
import { CLEAR_PROGRAM_SUCCESS } from "../Actions/ProgramAction";
import { TOAST_SHOW } from "../Actions/ToastAction";
import decryptResponse from "../../Components/Decrypt";

export function* LoginSaga(action) {
  try {
    const response = yield call(axios.post, `/login`, action.payload);
    const { status, data, message } = response?.data;
    let decryptData = decryptResponse(data);
    const token = decryptData.token;
    localStorage.setItem("token", token);
    yield put({ type: GET_USER_FOUND, payload: decryptData });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: status },
    });
  } catch (e) {
    yield put({ type: GET_USER_NOT_FOUND });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* editorSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-all-editors`,
      action?.payload
    );
    const { data } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({ type: GET_EDITOR_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_EDITOR_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* editorRemoveSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `/delete-editor-by-Id/${action?.payload?.Id}`,
      action.payload
    );
    const { message } = response?.data;
    yield put({ type: REMOVE_EDITOR_SUCCESS, payload: action?.payload });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REMOVE_EDITOR_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.type,
        severity: "error",
      },
    });
  }
}

export function* ValidateOtpSaga(action) {
  try {
    const response = yield call(axios.post, `/validate-otp`, action.payload);
    const { data, message } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({ type: VALIDATE_OTP_SUCCESS, payload: decryptData });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: VALIDATE_OTP_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* ForgetValidateOtpSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/send-email-to-reset-password`,
      action.payload
    );
    const { success, data, message } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: FORGET_VALIDATE_OTP_SUCCESS,
      payload: { decryptData, success },
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: FORGET_VALIDATE_OTP_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* RegisterSaga(action) {
  try {
    const response = yield call(axios.post, `/register-user`, action.payload);
    const { success, data, message } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: REGISTER_USER_SUCCESS,
      payload: { decryptData, success },
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REGISTER_USER_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* ForgetPassSaga(action) {
  try {
    const response = yield call(axios.post, `/forgot-password`, action.payload);
    const { success, message, status } = response?.data;
    if (success) {
      yield put({ type: FORGET_PASSWORD_SUCCESS, payload: status });
      yield put({ type: TOAST_SHOW, payload: { message } });
    }
  } catch (e) {
    yield put({ type: FORGET_PASSWORD_FAILED, payload: "Failed" });
    yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* ResetPassSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/reset-password-by-email-token`,
      action.payload
    );
    const { success, message } = response?.data;

    if (success) {
      yield put({ type: RESET_PASSWORD_SUCCESS, payload: success });
      yield put({
        type: TOAST_SHOW,
        payload: { message },
      });
      localStorage.clear();
    }
  } catch (e) {
    yield put({ type: RESET_PASSWORD_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* AccountVerificationSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/accept-invite/${action?.payload}`
    );
    const { success, message } = response?.data;
    if (success) {
      yield put({ type: ACCOUNT_VERIFICATION_SUCCESS, payload: message });
      yield put({ type: TOAST_SHOW, payload: { message } });
    }
  } catch (e) {
    yield put({
      type: ACCOUNT_VERIFICATION_FAILED,
      payload: e.response.data.errors.Error.message,
    });
  }
}
export function* EmailVerificationSaga(action) {
  try {
    const response = yield call(axios.get, `/email-verify/${action?.payload}`);
    const { success, message } = response?.data;
    if (success) {
      yield put({ type: EMAIL_VERIFICATION_SUCCESS, payload: message });
      yield put({ type: TOAST_SHOW, payload: { message } });
    }
  } catch (e) {
    yield put({
      type: EMAIL_VERIFICATION_FAILED,
      payload: e.response.data.errors.Error.message,
    });
  }
}

export function* LogoutSaga() {
  try {
    yield put({ type: LOGOUT_SUCCESS });
    yield put({ type: CLEAR_PROGRAM_SUCCESS });
    yield put({ type: CLEAR_BULLETIN_SUCCESS });
    yield put({ type: CLEAR_EXPLORE_SUCCESS });
    yield put({
      type: TOAST_SHOW,
      payload: { message: "Logout Successfully!", severity: "success" },
    });
  } catch (e) {
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: "Something Went wrong please try again",
        severity: "error",
      },
    });
  }
}

export function* AddExisitingUserSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/change-user-editor-status`,
      action.payload
    );
    const { success, data, message } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: REGISTER_EXISTING_USER_SUCCESS,
      payload: { decryptData, success },
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: REGISTER_EXISTING_USER_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
